import React, { useState } from "react";

export default function LabelInput({
  label,
  type = "text",
  name,
  icon,
  value,
  onChange,
  onBlur,
  onFocus,
  required = false,
  placeholder = "",
  maxLength,
  customValidator,
  capitalize = "none",
  error,
  disabled = false,
}) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const handleChange = (e) => {
    let newValue = e.target.value;

    // Apply capitalization
    if (capitalize === "uppercase") {
      newValue = newValue.toUpperCase();
    } else if (capitalize === "lowercase") {
      newValue = newValue.toLowerCase();
    }

    // Custom validation
    if (customValidator && !customValidator(newValue)) {
      return; // Don't update if validation fails
    }

    onChange?.({
      ...e,
      target: { ...e.target, name, value: newValue },
    });
  };

  const hasValue = value && value.toString().trim().length > 0;
  const shouldFloat = isFocused || hasValue;

  return (
    <div className="relative w-full">
      {/* Input Field */}
      <input
        id={name}
        name={name}
        type={type}
        value={value || ""}
        required={required}
        placeholder={shouldFloat ? placeholder : ""}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        maxLength={maxLength}
        disabled={disabled}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className={`
          w-full border rounded px-3 py-3 text-xs text-gray-800
          bg-white transition-all duration-200 focus:outline-none h-11
          ${error
            ? "border-red-500"
            : isFocused
              ? "border-gray-600"
              : "border-gray-300"
          }
          ${disabled
            ? "opacity-60 cursor-not-allowed bg-gray-50"
            : "hover:border-gray-600"
          }
        `}
      />

      {/* Floating Label */}
      {label && (
        <label
          htmlFor={name}
          className={`
            absolute left-3 px-1 bg-white transition-all duration-200 pointer-events-none
            ${error
              ? "text-red-600"
              : shouldFloat
                ? "text-black"
                : "text-gray-500"
            }
            ${shouldFloat ? "text-xs -top-2" : "text-xs top-3"}
          `}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}{" "}
        </label>
      )}

      {/* Error Message */}
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
}
